import React, { createContext, useState, useContext, ReactNode } from 'react';
import { Editor } from 'grapesjs';

interface FooterEditorContextType {
  editor: Editor | null;
  setEditor: React.Dispatch<React.SetStateAction<Editor | null>>;
}

const FooterEditorContext = createContext<FooterEditorContextType | undefined>(undefined);

interface FooterEditorProviderProps {
  children: ReactNode;
}

export const FooterEditorProvider: React.FC<FooterEditorProviderProps> = ({ children }) => {
  const [editor, setEditor] = useState<Editor | null>(null);

  editor?.on('canvas:drop', (dataTransfer, component) => {
    // only allow to drop one element in footer sections
    const components = editor.DomComponents;
    const wrapper = components.getWrapper();
    wrapper.get('components').reset();
    // Add the new component to the wrapper
    if (component) {
      wrapper?.append(component);
    }
  });

  return (
    <FooterEditorContext.Provider value={{ editor, setEditor }}>
      {children}
    </FooterEditorContext.Provider>
  );
};

export const useFooterEditor = (): FooterEditorContextType => {
  const context = useContext(FooterEditorContext);
  if (!context) {
    throw new Error('useFooterEditor must be used within a FooterEditorProvider');
  }
  return context;
};
